<template>
  <section>
    <div class="content">
      <transition name="fade">
        <div>
          <Titulo
            title="Envio de Imagens"
            description="Envie as imagens necessárias para criação do anúncio"
          />
          <div class="row no-gutters mt-4">
            <div class="col-md-8 d-md-block">
              <div
                class="arquivos-form p-4"
                :style="{ 'min-height': 110 + 'px' }"
              >
                <FormulateForm name="imagens" v-model="values">
                  <div class="lista-docs">
                    <FormulateInput
                      type="file"
                      :name="'logo'"
                      :label="'Imagem da Logo'"
                      @change="salvar('logo')"
                      @file-removed="remover('input_' + i + index)"
                      validation="mime:image/jpeg,image/png,image/x-eps"
                    />
                    <FormulateInput
                      type="file"
                      :name="'anuncios'"
                      :label="'Imagens do Anúncio'"
                      @change="salvar('anuncio')"
                      @file-removed="remover('anuncio')"
                      validation="mime:image/jpeg,image/png,image/x-eps"
                      multiple
                    />
                  </div>
                </FormulateForm>
              </div>
            </div>
          </div>
          <div class="row mt-5 flex-column-reverse flex-md-row">
            <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
              <Botao
                title="Voltar"
                link="/produto/clube-vantagens/painel"
                nameClass="btn btn-outline-secondary btn-lg btn-block"
                >VOLTAR</Botao
              >
            </div>
            <div class="col-md-5 col-lg-4">
              <Botao
                title="Próximo"
                @click="proximaEtapa()"
                nameClass="btn btn-cta btn-lg btn-block font-weight-bold"
                :class="{ disabled: disabled }"
              >
                <span
                  class="spinner-grow spinner-grow-sm pr-2"
                  role="status"
                  aria-hidden="true"
                  v-show="loading"
                ></span>
                PRÓXIMO</Botao
              >
            </div>
          </div>
        </div>
      </transition>
      <div class="py-5"></div>
    </div>
  </section>
</template>

<script>
import Titulo from "@/components/TituloPaginas";
import Botao from "@/components/botoes/Botao";

export default {
  name: "ListaVidas",
  components: { Titulo, Botao },
  data() {
    return {
      disabled: true,
      produto: {
        nome: "Clube de Vantagens",
        id: "ClubeVantagens",
      },
      breadcrumb: [
        {
          nome: "Clube de Vantagens",
          id: "ClubeVantagens",
          link: "/produto/clube-vantagens/painel",
        },
        {
          nome: "Envio de Imagens",
          id: "envioImagem",
        },
      ],
      values: {},
      listaArquivos: [],
      arquivosEnviados: [],
      registros: [],
      listaCpf: [],
      registroSel: null,
      arquivosSelecionados: {},
      statusDocumento: "",
      aceiteTermo: false,
      exibirTermo: false,
      cpfTitular: null,
      msgChamado: null,
      loading: false,
    };
  },
  methods: {
    async montaDados() {},
    remover(name) {
      this.arquivosEnviados = this.arquivosEnviados.filter(
        (e) => e.id !== name
      );
      this.registros[this.registroSel].arquivosConcluido = false;

      if (this.statusDocumento !== "Reprovado") {
        this.disabled = true;
      }
    },
    async salvar(name, vida, filename) {
      this.arquivosEnviados.push({
        file: this.values[`${name}`].fileList,
        iVida: vida,
        id: name,
        filename: filename,
      });

      if (this.statusDocumento !== "Reprovado") {
        this.disabled = !(await this.validarDocumentos());
      }
      const qtdArquivos = this.arquivosEnviados.filter(
        (el) => el.iVida === this.registroSel
      );

      if (
        qtdArquivos.length + 1 >=
        this.registros[this.registroSel].listaDocsObrigatorios.length
      ) {
        this.registros[this.registroSel].arquivosConcluido = true;
      } else {
        this.registros[this.registroSel].arquivosConcluido = false;
      }
    },
    proximaEtapa() {
      if (this.statusDocumento === "Reprovado") {
        this.enviarDocumentos();
      } else {
        this.exibirTermo = true;
      }
    },
    async enviarDocumentos() {
      if (
        (await this.validarDocumentos()) ||
        this.statusDocumento === "Reprovado"
      ) {
        this.loading = true;
        const form = new FormData();

        this.arquivosEnviados.forEach((el) => {
          form.append(
            "files",
            el.file[0],
            el.filename + el.file[0].name.substr(-4)
          );
        });

        this.listaCpf.forEach((el) => {
          form.append("cpf", el);
        });

        await this.$http
          .post(`/api/GestaoSaude/IncluirUsuariosPlanoVidaSaude`, form)
          .then((response) => {
            if (response.data.success && !response.data.erroAplicacao) {
              if (this.statusDocumento !== "Reprovado") {
                this.enviarAceite();
              } else {
                this.statusDocumento = "Em Atendimento";
              }
            }
          })
          .catch((error) => {
            console.error(error);
            this.$toast.open({
              message: "Erro no envio dos seus arquivos, tente novamente.",
              type: "error",
            });
            this.loading = false;
          });
      }
    },
    async validarDocumentos() {
      for await (const [vida, el] of this.listaArquivos.entries()) {
        for await (const i of el.keys()) {
          var name = "input_" + vida + i;
          if (typeof this.values[`${name}`] !== "undefined") {
            if (this.values[`${name}`].files.length === 0) {
              return false;
            }
          } else {
            return false;
          }
        }
      }
      return true;
    },
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
    this.montaDados();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";
.status {
  font-size: 14px;
  &.status-pendente {
    color: $success;
  }
}
.label {
  font-weight: 300;
  font-size: 1rem;
  margin-bottom: 3px;
  text-transform: capitalize;
}
.value {
  font-weight: bold;
  font-size: 1rem;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
.lista-botoes {
  button {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px;
    border: 0;
    background: white;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    margin-bottom: 10px;
    &.active {
      background: $dark-100;
    }
  }
}
.lista-registros /deep/ {
  .lista-docs {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
.arquivos-form /deep/ {
  @import "../../../../node_modules/@braid/vue-formulate/themes/snow/snow.scss";
  background: $dark-100;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  .formulate-input {
    label {
      margin-bottom: 5px;
    }
  }
  .formulate-input-upload-area {
    .formulate-input-upload-area-mask {
      background: white;
    }
  }
  .formulate-input[data-classification="file"]
    .formulate-files
    .formulate-file {
    background: white;
  }
}

@media screen and (max-width: 768px) {
  .lista-botoes {
    button {
      border-radius: 6px;
    }
  }
  .arquivos-form /deep/ {
    border-radius: 6px;
  }
}
</style>
